export default {"src":"/_next/static/media/guides.09ac2962.svg","height":218,"width":392};